export default [
  {
    key: 'starters',
    title: 'Entrées',
    items: [
      {
        title: 'soupe tom yum coco',
        description: 'Champignons, tomates cerises, ciboule thaï et coriandre fraîche',
        price: '4,2'
      },
      {
        title: 'salade de concombre aux 3 sésames',
        description: 'Sésame blanc, sésame noir, sésame wasabi',
        price: '4,2'
      },
      {
        title: 'riz sauté végétarien',
        description: 'Tofu 5 parfums, champignons, haricots verts, oeuf, gingembre',
        price: '4,2'
      }
    ]
  },
  {
    key: 'tapas',
    title: 'Tapas',
    items: [
      {
        title: 'ribs aux 5 parfums',
        description: 'Travers de Porc confits et caramélisés au four',
        price: '8'
      },
      {
        title: 'mini tartinettes de Banh-mi',
        description:
          '(dispo uniquement le soir & le week-end) Tous les ingrédients du fameux sandwich vietnamien en version tartine ! Version classique au porc xá xíu ou végétarienne au choix',
        price: '5,5'
      }
    ]
  },
  {
    key: 'springrolls',
    title: 'Rouleaux',
    items: [
      {
        title: 'crevette',
        description: 'Crevette, mangue, carottes pickles, cacahuètes, oignons frits',
        price: '4'
      },
      {
        title: 'veggie',
        description:
          'Avocat, omelette japonaise, oignons caramélisés déglacés au vinaigre balsamique, oignons frits',
        price: '4'
      },
      {
        title: 'tofu',
        description:
          'Tofu grillé à la citronnelle, poivron rouge, shiso, haricot, champignon de paris, cacahuète',
        price: '4'
      },
      {
        title: 'saumon fumé',
        description:
          'Saumon fumé d’Atlantique, roquette, oignons frits, fromage frais fouetté, pomme gala, concombre',
        price: '4'
      },
      {
        title: 'porc citronnelle',
        description:
          'Poitrine de porc grillé à la citronnelle, carottes pickles, concombre, cacahuètes',
        price: '4'
      },
      {
        title: 'saumon teriyaki',
        description: 'Pavé de saumon mariné au Teriyaki, oignons & gingembres grillés',
        price: '4'
      },
      {
        title: 'rouleau du moment',
        description: "Selon l'humeur du chef 😋",
        price: '4'
      }
    ]
  },
  {
    key: 'deserts',
    title: 'Desserts',
    items: [
      {
        title: 'panna cocotta',
        description: 'Panna cotta de lait de coco et son coulis de mangue',
        price: '3,9'
      },
      {
        title: 'pandan sponge cake',
        description: 'Gâteau nuageux au parfum d’Asie',
        price: '4'
      },
      {
        title: 'madeleines au thé vert matcha(x2)',
        description: '',
        price: '3,9'
      },
      {
        title: 'marbré sapa',
        description: 'Gâteau marbré au thé vert matcha',
        price: '4,9'
      },
      {
        title: 'le roulé de banoi',
        description: 'Gâteau roulé au sésame noir et crème chantilly de coco',
        price: '5'
      }
    ]
  },
  {
    key: 'drinks',
    title: 'Boissons',
    sections: [
      {
        sectionTitle: 'boissons fraîches',
        items: [
          {
            title: 'charitea maté',
            description: 'Maté effervescent à l’orange et citron – un plein de caféine !',
            price: '3,9'
          },
          {
            title: 'lemonaid fruit de la passion',
            description:
              'Boisson gazeuse rafraichissante au fruit de la passion réhaussée de mangue et de citron vert !',
            price: '3,9'
          }
        ]
      },
      {
        sectionTitle: 'boissons maison',
        items: [
          {
            title: 'Đá chanh',
            description: 'Citronnade vietnamienne minute',
            price: '4'
          },
          {
            title: 'thé glacé maison',
            description: 'Thé vert du Vietnam, miel & citron vert ou Thé noir Litchi sucre & citron jaune',
            price: '4,2'
          },
          {
            title: 'cà phê đá vietnamien',
            description: 'Café vietnamien glacé',
            price: '4,5'
          },
          {
            title: 'cà phê sua đá vietnamien',
            description: 'Café vietnamien frappé au lait concentré sucré',
            price: '4,8'
          },
          {
            title: 'cà phê đá cốt dừa',
            description:
              'Café frappé au lait de coco et lait concentré sucré (Option sans lactose/sans sucre disponible)',
            price: '5'
          }
        ]
      },
      {
        sectionTitle: 'boissons chaudes',
        items: [
          {
            title: 'cà phê vietnamien',
            description:
              'Café Robusta importé du Vietnam, aux notes « chocolatées », filtré à la vietnamienne',
            price: '3,5'
          },
          {
            title: 'cà phê sua vietnamien',
            description: 'Café du Vietnam au lait concentré sucré, comme au pays !',
            price: '4'
          },
          {
            title: 'thé Vert du Vietnam',
            description: '',
            price: '4'
          },
          {
            title: 'thé noir de Chine litchi',
            description: '',
            price: '4'
          },
          {
            title: 'thé au jasmin',
            description: '',
            price: '4'
          },
          {
            title: 'infusion detox comme à la maison',
            description: 'Menthe, Miel, Gingembre & Citron vert',
            price: '4,5'
          }
        ]
      },
      {
        sectionTitle: 'alcools',
        items: [
          {
            title: 'cocktail saigon royal iced tea',
            description: 'Gin 4cl, Thé Glacé au Litchi & Citron, ultra rafraichissant !',
            price: '8,5'
          },
          {
            title: 'bières',
            description: '- Hanoi beer, pale ale 5,1°, bouteille 33cl',
            description2: '- Saigon beer, pale ale 4,9° , bouteille 33cl',
            price: '4,5'
          },
          {
            title: 'Carte des vins',
            description: 'verre de vin 12,5cl',
            price: '4,5'
          },
          {
            title: 'bouteille de vin',
            description: '-« Rendez-vous », AOP Côte du Rhône, BIO 2023, Maison Le Jeune, 60% Grenache, 30% Carignan, 10% Cinsault',
            description2: '-« Lou de Mer », IGP Pays d’OC, BIO 2021, Maison Le Jeune, 100% Chardonnay',
            price: '25'
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/datas/MenuData.js